import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { GET_ME } from '../../graphql/queries';
import { identifyUser } from '../../utils/gt';

// Ties analytics to the signed-in account on every app page (this used to live in the old navbar's avatar)
export const AppSession = () => {
  const { data } = useQuery(GET_ME);
  const { username, name, email } = data?.me || {};

  useEffect(() => {
    if (username) identifyUser(username, name, email);
  }, [username, name, email]);

  return null;
};
